<template>
  <div>
    <!-- The ref attr used to find the swiper instance -->
    <template>
      <swiper :options="swiperOption" ref="mySwiper">
        <!--&lt;!&ndash; slides &ndash;&gt;-->
        <swiper-slide>
          <img src="../../static/images/banner/bg.jpg">
          <div class="title localServiceBanner">
            <div class="bigTitle">车联网位置服务平台</div>
            <div class="secondTitle">全新上线</div>
            <div class="thridTitle">
            	<span><img src="../../static/images/banner/icon.png"  />实时位置监控</span>
            	<span><img src="../../static/images/banner/icon.png"  />真实轨迹还原</span>
            	<span><img src="../../static/images/banner/icon.png"  />车辆BI分析</span>
            </div>
            <p class="square_button">
              <a href="http://clw.ishowchina.com:89/mygpsonline" target="_blank">立即体验</a>
            </p>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="../../static/images/banner/banner1bg.jpg">
          <div class="title">
            <div class="bigTitle">我秀中国 · 车伴侣</div>
            <div class="secondTitle">我们专注为您的企业提供轨迹大数据服务及行车位置监控服务</div>
            <div class="underTitle green">车辆端活跃量</div>
            <flip-num></flip-num>
          </div>

        </swiper-slide>
        
        <!--<swiper-slide>
          <img src="../../static/images/banner/banner3bg.png">
          <div class="title bigDataBanner">
            <div class="bigTitle"><img src="../../static/images/banner/banner3.png"></div>
            <div class="secondTitle">轨迹数据点、线、区域分布展示</div>
            <p class="square_button">
              <a href="#bigData">了解更多</a>
            </p>
          </div>
        </swiper-slide>-->
        <!-- Optional controls -->
        <div class="swiper-pagination"  slot="pagination">
        	<span class="swiper_icon"></span>
        	<span class="swiper_icon"></span>
        </div>
        <div class="swiper-button-prev" slot="button-prev" ></div>
        <div class="swiper-button-next" slot="button-next" ></div>
        <!--<div class="swiper-scrollbar"   slot="scrollbar"></div>-->
      </swiper>
      
    </template>
  </div>
</template>
<style lang="less" rel="stylesheet/less">
	.swiper-container{
		position: relative;
    overflow: hidden;
    z-index: 1;
    cursor: pointer !important;
    }
    .swiper-pagination-bullet-active{
    	background: #FFFFFF !important;
    }
    .swiper-pagination-bullet{
    	width:10px;
    	height:10px;
    	border-radius: 100%;
    	opacity: 0.8;
    	border:1px solid #fff;
    }
    .swiper-pagination{
    	position:absolute;
    	bottom:20px;
    	left:50%;
    	.swiper_icon{
    	display: inline-block;
    	width:8px;
    	height:8px;
    	border-radius: 100%;
    	background: #fff;
    	opacity: 0.8;
    	margin-left:5px;
    	cursor: pointer;
    	}
    }
    .swiper_cion{
    	position:absolute;
    	bottom: 20px;
    	left:50%;
    	.swiper_item{
    		float: left;
    		width:5px;
    		height: 5px;
    		border: 1px solid #FFFFFF;
    		border-radius: 5px;
    	}
    }
    .swiper-button-prev{
    	position:absolute;
    	top:50%;
    	left:20px !important;
    	width:38px !important;
    	height:38px !important;
    	background: url(../../static/images/banner/left.png) no-repeat 100% 100% !important;
    }
    .swiper-button-next{
    	position: absolute;
    	top:50%;
    	right:20px !important;
    	width:38px !important;
    	height:38px !important;
    	background: url(../../static/images/banner/right.png) no-repeat 100% 100% !important;
    }
  .swiper-slide {
  	float: left;
    height: 700px;
    position: relative;
    cursor:default;
    img {
      width: 100%;
      cursor: default;
    }
    .title {
      position: absolute;
      top: 0;
      width: 100%;
      margin-top: 7.0vw;
    }
    @media (max-width: 1366px) {
      .title {
        margin-top: 0vw;
      }
      .localServiceBanner{
      	 margin-top: 4vw;
      }
    }
    .bigTitle,.secondTitle{
      color: #fff;
      width: 100%;
      font-size: 3.75vw;
      color: #9bc765;
      font-weight: 600;
      letter-spacing: 5px;
      img {
        width: auto;
      }
    }
    .secondTitle,.underTitle {
      text-align: center;
      font-size: 1.875vw;
      /*color: #fff;*/
      font-weight: 400;
    }
    .secondTitle {
      color: #fff;
    }
    .underTitle {
      font-size: 1.3vw;
      margin-bottom: 15px;
    }
    .localServiceBanner {
      width: 60%;
      margin-left: 20%;
      .bigTitle {
        font-size: 3.38vw;
        font-weight: 500;
        color: #FFFFFF;
      }
      .bigTitle,.secondTitle,.thridTitle{
        text-align: center;
        color: #FFFFFF;
      }
      .secondTitle {
        font-size: 2.3625vw;
        font-weight: 500;
      }
      .thridTitle{
      	font-size: 1.0vw;
      	font-weight: 500;
      	letter-spacing: 3px;
      	img{
      		width:16px;
      		height:16px;
      		vertical-align: middle;
      		margin-right:5px;
      		cursor: ;
      	}
      }
      .square_button {
        text-align: center;
        margin-top: 40px;
        a {
        	border-radius: 50px;
          padding: 8px 85px;
          border-color:#BFCAD3;
          color:#fff;
        }
      }
    }
    .bigDataBanner {
      .square_button{
        margin-top: 50px;
        a {
          border:1px solid #fff;
          color: #fff;
        }
      }
    }
  }
  .swiper-wrapper {
    margin-bottom: -4px;
  }
  .swiper-scrollbar {
    display: none;
  }

</style>
<script>
  import flipNum from './flipnum.vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
//   swiper options example:
  export default {
    name: 'carrousel',
    components: {
      'flip-num': flipNum,
      swiper,
    	swiperSlide
    },
    data () {
      return {
        swiperOption: {
//        NotNextTick is a component's own property, and if notNextTick is set to true, the component will not instantiate the swiper through NextTick, which means you can get the swiper object the first time (if you need to use the get swiper object to do what Things, then this property must be true)
//        notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
          notNextTick: true,
//        swiper configs 所有的配置同swiper官方api配置
          initialSlide: 0,
          autoplay: 5000,
          direction: 'horizontal',
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
         // width: window.innerWidth,
          height: window.innerHeight,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
//          scrollbar: '.swiper-scrollbar',
//          scrollbarHide: true,
          mousewheelControl: false,
          observeParents: true,
          loop: false,
//        if you need use plugins in the swiper, you can config in here like this
//        如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
          debugger: true,
//        swiper callbacks
//        swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
          onTransitionStart (swiper) {
//            console.log(swiper)
          }
//         more Swiper configs and callbacks...
//         ...
        }
      }
    },
//     you can find current swiper instance object like this, while the notNextTick property value must be true
//     如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
    computed: {
      swiper () {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted () {
//       you can use current swiper instance object to do something(swiper methods)
//       然后你就可以使用当前上下文内的swiper对象去做你想做的事了
//      console.log('this is current swiper instance object', this.swiper)
//      this.swiper.slideTo(0, 1000, false)
    },
    methods: {
    	/*pageTurn(){
    		var curEl=document.getElementsByClassName("swiper-slide");
    		for(var i=0; i< curEl.length; i++){
    			if(i==0){
    				curEl[i].classList.remove("swiper-slide-active");
    				curEl[i+1].classList.add("swiper-slide-active");
    			}else{
    				curEl[i].classList.add("swiper-slide-active");
    				curEl[i+1].classList.remove("swiper-slide-active");
    			}
    		}
    	}*/
    }
  }
</script>




// WEBPACK FOOTER //
// banner.vue?c8ffa37a